import { render } from "./SaveConfigure.vue?vue&type=template&id=0e50af92&scoped=true"
import script from "./SaveConfigure.vue?vue&type=script&lang=js"
export * from "./SaveConfigure.vue?vue&type=script&lang=js"

import "./SaveConfigure.vue?vue&type=style&index=0&id=0e50af92&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e50af92"]])

export default __exports__